import React from "react";
import { Link } from "react-router-dom";
import "./hero.css";

export default function Hero({ t, subtitle, compact = false }) {
  return (
    <section className={`trade-hero ${compact ? "trade-hero--compact" : ""}`}>
      <div className="container trade-hero__layout">
        <div className="trade-hero__copy">
          <span className="trade-hero__eyebrow">Italiano988 · Import & Export</span>
          <h1>{compact ? t("services") : t("herotitle")}</h1>
          <p>{compact ? subtitle : t("herodesc")}</p>
          <div className="trade-hero__actions">
            <Link to="/contact" className="trade-hero__primary">{t("prices")} <span aria-hidden="true">↗</span></Link>
            <Link to="/services" className="trade-hero__secondary">{t("services")} <span aria-hidden="true">→</span></Link>
          </div>
          <div className="trade-hero__footnote"><span />{subtitle}</div>
        </div>
        <div className="trade-hero__art" aria-hidden="true">
          <div className="trade-hero__globe" />
          <div className="trade-hero__route trade-hero__route--one" />
          <div className="trade-hero__route trade-hero__route--two" />
          <div className="trade-hero__point trade-hero__point--one" />
          <div className="trade-hero__point trade-hero__point--two" />
          <div className="trade-hero__point trade-hero__point--three" />
          <span className="trade-hero__art-label trade-hero__art-label--top">01 / GLOBAL TRADE</span>
          <div className="trade-hero__ship">
            <div className="trade-hero__containers"><span /><span /><span /><span /><span /><span /></div>
            <div className="trade-hero__bridge" />
            <div className="trade-hero__hull" />
            <div className="trade-hero__wave" />
          </div>
          <span className="trade-hero__art-label trade-hero__art-label--bottom">ITALIANO988 / WORLDWIDE</span>
        </div>
      </div>
    </section>
  );
}
